export class ProcedimentoAgendaTomadaPk {

    idFilial: number = 0;

    idProcedimento: number = 0;

    idMedico: number = 0;

    diaSemana: number = 0;

    horaAtendimento: string = '';

    horaTomada: string = '';

    constructor() {
    }
}
